import Vue from 'vue'

import Interno from './components/Interno'
import Externo from '@/shared/layouts/adminlte/components/Externo'
Vue.component('Interno', Interno)
Vue.component('Externo', Externo)